const EN_US = { 'eversightDomain.title': 'Eversight' } as const

export default EN_US
